<template>
  <div class="add-question-by-product-code-step">
    <i-steps :current="current">
      <i-step title="筛选试题"></i-step>
      <i-step title="筛选型号"></i-step>
      <i-step title="添加试题"></i-step>
    </i-steps>
  </div>
</template>

<script>
export default {
  name: 'AddQuestionByProductCodeStep',
  props: {
    current: { type: Number, required: true },
  },
};
</script>

<style lang="less" scoped>
.add-question-by-product-code-step {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 36px 0;

  /deep/ .ivu-steps {
    width: 60%;
  }
}
</style>
